import InteractiveProposalSolution from "../../InteractiveProposal/menuPages/InteractiveProposalSolution";

function SolutionintRev() {
  return (
    <div>
      <InteractiveProposalSolution isIntReactiveRevCent />
    </div>
  );
}
export default SolutionintRev;
